import { styled } from "@mui/material/styles"
import Tabs from "@mui/material/Tabs"

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  padding: "0 12px",
  borderBottom: `1px solid ${theme.palette.gray[5]}`,

  "& .MuiTabs-flexContainer": {
    justifyContent: "center"
  },

  "& button": {
    minWidth: "72px",
    color: theme.palette.gray["16"],
    fontSize: "1.4rem",
    fontWeight: "normal",

    "& span": {
      fontFamily: "VazirmatnFD, serif !important"
    },

    "&:not(:last-child)": {
      "&:after": {
        content: "''",
        width: "2px",
        height: "70%",
        position: "absolute",
        top: "50%",
        right: 0,
        transform: "translateY(-50%)",
        borderRight: `1px solid ${theme.palette.gray[5]}`
      }
    }
  },

  "& button.Mui-selected": {
    color: theme.palette.primary["6"],
    fontWeight: "500 !important"
  },

  "& .MuiTabs-indicator": {
    backgroundColor: "transparent"
  }
}))
